export const API_TIMEOUT_TIERS = {
    DEFAULT: 1250,
    LOW: 2500,
    MEDIUM: 5000,
    HIGH: 10000,
    VERY_HIGH: 30000,
    EXTREMELY_HIGH: 90000,
    NONE: 0,
};
export const MAX_RETRIES = 2;
export const getQueryTimeoutMs = (timeouts) => {
    const productionMs = timeouts?.productionMs ?? API_TIMEOUT_TIERS.DEFAULT;
    const devMs = timeouts?.devMs ?? API_TIMEOUT_TIERS.HIGH;
    const clientSideMs = timeouts?.clientSideMs ?? API_TIMEOUT_TIERS.MEDIUM;
    if (typeof window !== 'undefined') {
        return clientSideMs;
    }
    // Built server gets shorter default timeout than dev server
    return process.env.NODE_ENV === 'production' ? productionMs : devMs;
};
//# sourceMappingURL=utils.js.map